<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>

import UPDATE from "@/components/page/update.vue";
import tablePage from "@/components/page/table.vue";
import FORM from "@/components/page/form.vue";
import URL from "@/views/newmis36/util/url";
import {dataChange} from '@/utils/dataChange';

let systemMap = {};

export default {
  components: {
    FORM,
    UPDATE,
    tablePage
  },
  created () {
    this.getOptions();
  },
  mounted(){
    // console.log("System option list: ", this.systemOptionList);
    this.$set(this.formData.cols[2], "optionList", this.systemOptionList);
    this.$set(this.updateData.cols[3], "optionList", this.systemOptionList);
    this.$forceUpdate();
  },
  methods: {
    formClick (clickName, data) {
      // console.log("formClick: ", clickName, data);
      if (clickName === "init") {
        this.$refs.childTable.defaultQueryData(this.queryData);
      } else if (clickName === "query") {
        this.queryData = data;
        if (this.queryData.system) {
          this.queryData.system = systemMap[this.queryData.system];
        }
        this.$refs.childTable.defaultGetData(this.queryData);
      } else if (clickName === "add") {
        this.modalData = {};
        this.$refs.childUpdate.open(this.modalData);
      }
    },
    bthClick (clickName, row) {
      // console.log("bthClick: ", clickName, row);
      if (clickName === "update") {
        this.modalData = {};
        this.modalData.id = row.id;
        this.modalData.channel = row.channel;
        this.modalData.code = row.code;
        this.modalData.system = Object.keys(systemMap).find(key => systemMap[key] === row.system);
        this.modalData.system = parseInt(this.modalData.system, 10);
        // console.log("Update data: ", this.modalData);
        this.$refs.childUpdate.open(this.modalData);
      } else if (clickName === "delete") {
        if (!row.id) this.$message.error(window.$t("txmis.socialMedia.message.invalid"));
        this.delete(row.id)
      }
    },
    submit (payload) {
      // console.log("submit: ", payload, systemMap);
      if (payload.system) {
        payload.system = systemMap[payload.system];
      }
      this.saveOrUpdate(payload);
    },
    getOptions () {
      dataChange(URL.socialMedia.channel.options, {}, (res) => {
        if(res.code === 0) {
          // console.log(res);
          systemMap = res.result ? res.result.systems : {};
          for (const [key, value] of Object.entries(systemMap)) {
            this.systemOptionList.push({key: parseInt(key, 10), value: value});
          }
        }
      }, (err) => {this.errorHandle(err)})
    },
    saveOrUpdate (data) {
      let url = URL.socialMedia.channel.add;
      if (data.id) {
        url = URL.socialMedia.channel.update;
      }
      dataChange(url, data, (res) => {
        // console.log(res);
        if (res.code === 0) {
          if(res.result) {
            this.$message.success(window.$t("txmis.socialMedia.message.success"));
          } else {
            this.$message.error(window.$t("txmis.socialMedia.message.fail") +
              window.$t("txmis.socialMedia.message.duplicate"));
          }
          this.$refs.childUpdate.close();
          this.modalData = {};
        }
      }, (err) => {this.errorHandle(err)}, "POST", "json").then(() => {
        this.$refs.childUpdate.close();
        this.refreshTable();
      });
    },
    delete (id) {
      // console.log("delete: ", id);
      let url = URL.socialMedia.channel.delete + "/" + id;
      dataChange(url, {}, (res) => {
        // console.log(res);
        if (res.code === 0) {
          this.successHandle(res);
        }
      }, (err) => {this.errorHandle(err)}).then(() => {
        this.refreshTable();
      });
    },
    successHandle (success) {
      if(success.result) {
        this.$message.success(window.$t("txmis.socialMedia.message.success"));
      } else {
        this.$message.error(window.$t("txmis.socialMedia.message.fail"));
      }
    },
    errorHandle(error) {
      const errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        window.$t("txmis.socialMedia.message.unknown");
      this.$message.error(
        window.$t("txmis.socialMedia.message.fail") + ": " + errorMessage
      );
    },
    refreshTable() {
      this.$refs.childTable.defaultGetData(this.queryData);
      this.$forceUpdate();
    }

  },
  data() {
    return {
      // OptionList data
      systemOptionList: [],
      // Data
      queryData:{},
      modalData:{},
      // Query form
      formData: {
        hasLable : true,
        initClickName: "init",
        cols:[
          { title: window.$t("txmis.socialMedia.channel.form.name.label"), field: "channel" },
          { title: window.$t("txmis.socialMedia.channel.form.code.label"), field: "code" },
          { title: window.$t("txmis.socialMedia.channel.form.system.label"), field: "system", type: 2, optionList: [] },
          { buttonLabel: window.$t("txmis.bt.query"), click: "query"},
          { buttonLabel: window.$t("txmis.bt.add"), click: "add"}
        ]
      },
      // Table
      pageData: {
        queryUrl: URL.socialMedia.channel.page,
        method: "post-json",
        sequence: true,
        cols: [
          { title: window.$t("txmis.socialMedia.common.id"), field: "id", hidden: true },
          { title: window.$t("txmis.socialMedia.channel.table.channel"), field: "channel" },
          { title: window.$t("txmis.socialMedia.channel.table.code"), field: "code" },
          { title: window.$t("txmis.socialMedia.channel.table.system"), field: "system" },
          { title: window.$t("txmis.socialMedia.common.createdAt"), field: "createdAt" },
          { title: window.$t("txmis.socialMedia.common.updatedAt"), field: "updatedAt", render:(data, full) => {
              return data ? data : "";
            } },
          { title: window.$t("txmis.bt.operation"), btnClick: [
              { name: window.$t("txmis.bt.edit"), size: "mini", click: "update", type: "primary", icon: "el-icon-edit" },
              { name: window.$t("txmis.bt.delete"), size: "mini", click: "delete", type: "danger", icon: "el-icon-delete" }
            ]
          }
        ]
      },
      // Add/Update modal
      updateData: {
        cols: [
          { title: window.$t("txmis.socialMedia.common.id"), field: "id", hidden: true},
          { title: window.$t("txmis.socialMedia.channel.modal.channel.label"), field: "channel", require: true,
            placeholder: window.$t("txmis.socialMedia.channel.modal.channel.placeholder") },
          { title: window.$t("txmis.socialMedia.channel.modal.code.label"), field: "code", require: true,
            placeholder: window.$t("txmis.socialMedia.channel.modal.code.placeholder") },
          { title: window.$t("txmis.socialMedia.channel.modal.system.label"), field: "system", type: 2, optionList: [], require: true }
        ]
      }
    }
  }
}

</script>

<style scoped>

</style>
